import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Drawer, notification, Row } from 'antd'
import { TableComp } from 'sz-react-utils-lite'
import {
  editWithdrawalLimitFxn,
  getAllWithdrawalLimitFxn, getPendingWithdrawalFxn
} from '../actions/user'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { countryIds, DefaultTablePagination, InputBox } from '../../../components/_utils/appUtils'
import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'

const UsedLimitWithdrawalList = (props) => {
  const { visible, onClose, countryId, record } = props
  const dispatch = useDispatch()
  const tableRef2 = useRef()
  const currency =
    record && record.countryId && record.countryId.currency &&
    record.countryId.currency || '--'

  const remainingLimit = record && record.remainingLimit || 0

  const [total, setTotal] = useState(0)
  const [withdrawalLimitId, setWithdrawalLimitId] = useState('')
  const [selectedIds, setSelectedIds] = useState([])
  const [selectedAmount, setSelectedAmount] = useState(0)
  const [withdrawalLimits, setWithdrawalLimit] = useState([])
  const [withdrawalLimitIds, setWithdrawalLimitIds] = useState([])
  const [limit, setLimit] = useState(record.withdrawalLimit || 0)
  const [availableLimit, setAvailableLimit] = useState(remainingLimit || 0)
  const [agentId, setAgentId] = useState('')
  const [selectAll, setSelectAll] = useState(false)
  const [tableData, setTableData] = useState([])

  // console.log(selectedIds, 'selectedIds')
  // console.log(selectedAmount, 'selectedAmount')
  useEffect(() => {
    countryId && fetchWithdrawalLimit()
  }, [countryId, withdrawalLimits.length, withdrawalLimitId])


  const apiRequest = async (params) => {
    params.results = 1000
    params.count = 1000
    params.countryId = countryId
    params.status = 'Pending'
    if (record && record._id) {
      params.withdrawalLimitId = record._id
    }
    if (agentId) {
      params.agentId = agentId
    }
    if (record._id) {
      const { data } = await dispatch(getPendingWithdrawalFxn(params))
      setTableData(data.data)
      setTotal(data.total)
      return data
    }
  }


  useEffect(() => {
    if (withdrawalLimitId || agentId) {
      tableRef2.current.reload()

    }
  }, [withdrawalLimitId, agentId])

  const fetchWithdrawalLimit = async () => {
    const params = {
      countryId,
      results: 1000,
      count: 1000,
      _id: { $ne: record._id }
    }

    let response = await dispatch(getAllWithdrawalLimitFxn(params))
    console.log(response, 'response')
    if (response && response.data && response.data.data) {
      const data = response.data.data
      setWithdrawalLimit(data)

      // Extract all _id values into an array
      const allIds = data.map(item => item._id)
      setWithdrawalLimitIds(allIds)
      tableRef2.current.reload()
    }
  }


  const handleCheckboxChange = (id, checked, record) => {
    if (checked) {
      setSelectedIds(prev => [...prev, id])
      setSelectedAmount(prev => prev + (record.amount || 0))
    } else {
      setSelectedIds(prev => prev.filter(item => item !== id))
      setSelectedAmount(prev => prev - (record.amount || 0))
    }
  }

  const handleSelectAllChange = (checked, dataSource = []) => {
    setSelectAll(checked)

    if (checked) {
      const allIds = dataSource.map(item => item._id)
      const totalAmount = dataSource.reduce((sum, item) => sum + (item.amount || 0), 0)

      setSelectedIds(allIds)
      setSelectedAmount(totalAmount)
    } else {
      setSelectedIds([])
      setSelectedAmount(0)
    }
  }

  const handleLimitChange = (val) => {
    setLimit(val)
  }

  const columns = [
    {
      title: (
        <label style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
          Select All
          <input
            style={{ marginLeft: '1px' }}
            type='checkbox'
            checked={selectAll}
            onChange={(e) => handleSelectAllChange(e.target.checked, tableData)}
          />
        </label>
      ),
      key: 'checkbox',
      dataIndex: '_id',
      width: 20,
      render: (id, record) => (
        <input
          type='checkbox'
          checked={selectedIds.includes(id)}
          onChange={(e) => handleCheckboxChange(id, e.target.checked, record)}
        />
      )
    },
    {
      title: 'Agent',
      key: 'agentId',
      dataIndex: 'agentId',
      width: 150,
      render: (agent) => (
        <div>
          {(agent && agent.companyName ? agent.companyName : '')}
          {(agent && agent.name ? ` (${agent.name})` : '')}
        </div>
      )
    },
    {
      title: 'Amount',
      key: 'amount',
      dataIndex: 'amount',
      width: 80,
      render: (amount, record) => (
        <div>
          {(record && record.countryId && record.countryId.currency ? record.countryId.currency : '')}
          {amount}
        </div>
      )
    },
    {
      title: 'Release Date',
      key: 'withdrawalReleaseDate',
      dataIndex: 'withdrawalReleaseDate',
      width: 100,
      render: (date) => (
        <div>{date ? moment(date).format('DD-MM-YYYY') : '--'}</div>
      )
    }
  ]

  const handleSubmit = async () => {

    if (!selectedIds.length) {
      return notification.warning({
        message: 'Please choose at least one withdrawal to proceed'
      })
    }

    if (limit < record.withdrawalLimit) {
      return notification.warning({
        message: 'Updated limit cannot be less than withdrawal limit'
      })
    }

    if (selectedAmount > availableLimit) {
      return notification.warning({
        message: 'Selected Amount limit cannot be greater than current limit'
      })
    }

    let body = {
      withdrawalReleaseDate: record.withdrawalLimitDate,
      withdrawalLimitId: record._id,
      selectedIds
    }

    if (limit != record.withdrawalLimit) {
      body.newWithdrawalLimit = limit
    }

    const resp = await dispatch(editWithdrawalLimitFxn(body))
    if (resp.success) {
      onClose()
    }
  }

  useEffect(() => {
    if (tableData.length) {
      setSelectAll(selectedIds.length == tableData.length)
    }
  }, [selectedIds, tableData])

  useEffect(() => {
    if (limit) {
      let newAvailableLimit = limit - record.usedLimit
      setAvailableLimit(newAvailableLimit)
    }
  }, [limit])

  return (
    <Drawer
      title='Edit Withdrawal Limit'
      width='60%'
      onClose={onClose}
      visible={visible}
    >
      <div className='card'>
        <Col span={24}>
          <div className='row p-4'>

            <div className='col-md-4 mb-2'>
              <div className='p-2 bg-light text-success border rounded-pill fs-4 shadow-sm'>
                <strong className={'ml20'}>Date:</strong> {record.withdrawalLimitDate
                ? moment(record.withdrawalLimitDate).format('DD MMM YYYY')
                : '--'}
              </div>
            </div>

            <div className='col-md-4 mb-2'>
              <div className='p-2 bg-light text-success border rounded-pill fs-2 shadow-sm'>
                <strong className={'ml20'}> Country: </strong>
                {countryId == countryIds.canada ? 'Canada' :
                  countryId == countryIds.uk ? 'Uk' : ''}
              </div>
            </div>

            <div className='col-md-4 mb-2'>
              <div className='p-2 bg-light text-warning border rounded-pill fs-2 shadow-sm'>
                <strong className={'ml20'}>Available
                  :</strong> {currency} {availableLimit && (availableLimit).toFixed(2) || '--'}
              </div>
            </div>

            <div className='col-md-4'>
              <div
                className='p-2 bg-light text-success border rounded-pill fs-2 shadow-sm d-flex align-items-center'>
                <strong className='me-2 ml20'>Limit:</strong>
                <span className='ml5'>{currency}</span>
                <input
                  type='number'
                  className={'ml10'}
                  style={{
                    height: '25px',
                    cursor: 'pointer',
                    border: 'none',
                    color: 'blue',
                    textDecoration: 'underline',
                    textDecorationColor: 'blue',
                    textDecorationThickness: '1px'
                  }}
                  // className='border-0 bg-transparent text-success fs-2 flex-grow-1 ml5'
                  value={limit}
                  onChange={(e) => handleLimitChange(e.target.value)}
                />
              </div>
            </div>

            <div className='col-md-4 mb-2'>
              <div className='p-2 bg-light text-danger border rounded-pill fs-2 shadow-sm'>
                <strong
                  className={'ml20'}> Used:</strong> {currency} {record.usedLimit && (record.usedLimit).toFixed(2) || '--'}
              </div>
            </div>


            <div className='col-md-4 mb-2'>
              <div className='p-2 bg-light text-info border rounded-pill fs-2 shadow-sm'>
                <strong className={'ml20'}>Selected
                  :</strong> {currency} {selectedAmount && (selectedAmount).toFixed(2) || 0}
              </div>
            </div>

          </div>
        </Col>

        <div className='table-head d-flex align-items-center'>
          <h5>Choose Withdrawal</h5>
        </div>
        <div className='card-body table-responsive'>
          <Row gutter={16}>
            <Col span={8}>
              <InputBox title={'Withdrawal Limits'}>
                <select
                  className='form-control'
                  value={withdrawalLimitId}
                  onChange={({ target }) => {
                    setWithdrawalLimitId(target.value)
                  }}
                >
                  <option value=''>Choose Withdrawal Limit</option>
                  {withdrawalLimits && withdrawalLimits.length > 0 &&
                  withdrawalLimits.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.withdrawalLimitDate &&
                      moment(item.withdrawalLimitDate).format('DD-MM-YYYY')}
                    </option>
                  ))}
                </select>
              </InputBox>
            </Col>

            <Col span={8}>
              <InputBox title={'Search By Agent'} labelCls='labelDoc'>
                <AgentTypeheadComponent
                  key={agentId}
                  agentId={agentId}
                  dispatch={dispatch}
                  customStyle=''
                  onSelect={(item) => setAgentId(item)}
                />
              </InputBox>
            </Col>
          </Row>
          <TableComp
            columns={columns}
            rowKey='_id'
            ref={tableRef2}
            apiRequest={apiRequest}
            pagination={DefaultTablePagination({ defaultPageSize: 1000 })}
          />
          {/*<div style={{ marginTop: 20 }}>
            <strong>Selected IDs:</strong> {JSON.stringify(selectedIds)}
          </div>*/}
          <Button
            type='primary'
            htmlType='submit'
            className='btn btn-success-dark'
            onClick={handleSubmit}
          >
            Update
          </Button>
        </div>
      </div>
    </Drawer>
  )
}

export default UsedLimitWithdrawalList